import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_DELETED_ENTITIES_LIST = "GET_DELETED_ENTITIES_LIST";

export const service = async (data) => {
    const options: object = {
        url: `/Api/Audit/GetDeletedEntityList`,
        method: "GET",
    };
    const response = callMvcApi(options);
    return response;
};

const mockData = () => {
    return [];
};

const mock = () => {
    const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockData());
        }, 2000);
    });
    return promise;
};

register(GET_DELETED_ENTITIES_LIST, service, mock);
